import { render, staticRenderFns } from "./BdTicket.vue?vue&type=template&id=1de628fa&"
import script from "./BdTicket.vue?vue&type=script&lang=js&"
export * from "./BdTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports